export const weekdayHU = [
    { id: '0', name: 'Hétfő', shortName: 'H'  },
    { id: '1', name: 'Kedd', shortName: 'K'  },
    { id: '2', name: 'Szerda', shortName: 'Sze'  },
    { id: '3', name: 'Csütörtök', shortName: 'Cs'  },
    { id: '4', name: 'Péntek', shortName: 'P'  },
    { id: '5', name: 'Szombat', shortName: 'Szo'  },
    { id: '6', name: 'Vasárnap', shortName: 'V'  },
  ];